import { render, staticRenderFns } from "./AssignDropoffLocations.vue?vue&type=template&id=09913862&scoped=true"
import script from "./AssignDropoffLocations.vue?vue&type=script&lang=js"
export * from "./AssignDropoffLocations.vue?vue&type=script&lang=js"
import style0 from "./AssignDropoffLocations.vue?vue&type=style&index=0&id=09913862&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09913862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09913862')) {
      api.createRecord('09913862', component.options)
    } else {
      api.reload('09913862', component.options)
    }
    module.hot.accept("./AssignDropoffLocations.vue?vue&type=template&id=09913862&scoped=true", function () {
      api.rerender('09913862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BrandSettings/AssignDropoffLocations.vue"
export default component.exports